import React from "react";
import { getParamsData } from "../services/City";

const SelectField = React.memo((props) => {
  const [value, setValue] = React.useState(null);
  const [data, setData] = React.useState(null);
  React.useEffect(() => {
    getParamsData(props.id, 1).then((res) => {
      setData(res);
    });
    if (props.value) setValue(props.value.slice(1, props.value.length - 1));
  }, []);

  const onChange = (e) => {
    if (props.id == 18 || props.id == 14) {
      document.getElementById('lable' + props.id).style.color = "#191617";

    }
    if (props.id == 197) {
      document.getElementById('param' + props.id).removeAttribute('style');
      document.getElementById("PresentOther").style.display = 'none';
      if (e.target.value == 'Other') {
        document.getElementById("PresentOther").style.display = 'inline-block';
        document.getElementById("PresentUseID").style.display = 'none';
      }
    }
    props.data.find((item) => item.ParameterId === props.id).Value = e.target.value;
    props.setData(
      props.data.map((item) => {
        return item.ParameterId === props.id
          ? { ...item, Value: e.target.value }
          : item;
      })
    );
  };
  if (props.id == 20 || props.id == 22 || props.id == 24 || props.id == 26 || props.id == 83 || props.id == 13 || props.id == 14 || props.id == 317
    || props.id == 195 || props.id == 219 || props.id == 228 || props.id == 220 || props.id == 196) {
    return (

      <>
        <div class="form-group col-md-3 ">
          <label >{props.name}</label>
          <select class="form-control" onChange={onChange} required id={'param' + props.id}>

            {data &&
              data?.map((item, index) => {
                return (
                  <option selected={item.Value === value} value={item.Value}>
                    {item.Value}
                  </option>
                );
              })}
          </select>
        </div>
      </>
    );
  }
  else {
    if (props.id == 197) {
      return (

        <>
          <div class="form-group col-md-3 " id="PresentUseID">
            <label >{props.name}</label>
            <select class="form-control" onChange={onChange} required id={'param' + props.id}>
              <option selected="selected" value={""}>Choose {props.name}</option>
              {data &&
                data?.map((item, index) => {
                  return (
                    <option selected={item.Value === value} value={item.Value}>
                      {item.Value}
                    </option>
                  );
                })}
            </select>
          </div>
        </>
      );

    }
    if (props.id == 14) {
      return (

        <>
          <div class="form-group col-md-3 " id="PresentUseID">
            <label id={'lable' + props.id}>{props.name}</label>
            <select class="form-control" onChange={onChange} required id={'param' + props.id}>
              <option selected="selected" value={""}>Choose Yes or No</option>
              {data &&
                data?.map((item, index) => {
                  return (
                    <option selected={item.Value === value} value={item.Value}>
                      {item.Value}
                    </option>
                  );
                })}
            </select>
          </div>
        </>
      );

    }
    else {
      return (

        <>
          <div class="form-group col-md-3 ">
            <label id={'lable' + props.id}>{props.name}</label>
            <select class="form-control" onChange={onChange} required id={'param' + props.id}>
              <option selected="selected" value={""}>Choose {props.name}</option>
              {data &&
                data?.map((item, index) => {
                  return (
                    <option selected={item.Value === value} value={item.Value}>
                      {item.Value}
                    </option>
                  );
                })}
            </select>
          </div>
        </>
      );
    }
  }
});

export default SelectField;
